<template>
    <div>
        <div class="row">
            <div class="col-12">
                <table class="table simple-table table-bordered table-sm">
                    <thead class="thead-dark">
                    <tr>
                        <th scope="col" class="text-center">{{ $lang('Komponent (JIRA)') }}</th>
                        <th scope="col" class="text-center d-none d-md-table-cell"></th>
                        <th scope="col" class="text-center">{{ $lang('Moduł (SOS)') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(component, index) in componentsEditable">
                        <td :data-title="$lang('Komponent (JIRA)')">{{ component.name }}</td>
                        <td class="text-center d-none d-md-table-cell"><i class="fa fa-arrow-circle-right fa-2x" aria-hidden="true"></i></td>
                        <td :data-title="$lang('Moduł (SOS)')">
                            <select :id="createID(component.id)" class="form-control"
                                    v-model="componentsEditable[index].module_id">
                                <option v-if="component.module_id === null" selected value=""></option>
                                <option :selected="component.module_id === module.id" v-for="module in modules"
                                        :value="module.id">{{ module.name }}
                                </option>
                            </select>
                            <small v-if="duplicates.includes(component.id)" class="text-red">{{$lang('Wybrany moduł jest już przypisany do innego komponentu')}}</small>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-12">
                <button id="choose-criterion" :disabled="duplicates.length > 0" @click.prevent="save" type="button" class="btn btn-primary pull-right">
                    {{ $lang('Zapisz') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import ShowNotification from "../../mixins/show-notification";

export default {
    name: "project-modules",
    mixins: [ShowNotification],
    props: {
        components: {
            type: Array,
            required: true,
        },
        modules: {
            type: Array,
            required: true
        },
        saveRoute: {
            type: String,
            required: true
        }
    },
    computed: {
        duplicates() {
            let ids = this.componentsEditable.map(x => x.module_id);

            const uniq = ids
                .filter(x => x !== undefined)
                .map((name) => {
                    return {
                        count: 1,
                        name: name
                    };
                })
                .reduce((result, b) => {
                    result[b.name] = (result[b.name] || 0) + b.count;

                    return result;
                }, {});
            let duplicates =  Object.keys(uniq).filter((a) => uniq[a] > 1);

            return this.componentsEditable.filter(function (component) {
                return component.module_id !== undefined && duplicates.includes(component.module_id.toString());
            }).map(x => x.id);
        }
    },
    methods: {
        createID(id) {
            return "select_module_" + id;
        },

        save() {
            let self = this;
            axios.post(this.saveRoute, {components: this.componentsEditable})
                 .then(function (response) {
                     self.showNotification('success', self.$lang('Zapisano!'));
                 })
                 .catch(function (error) {
                     self.showNotification('error', self.$lang('Błąd zapisu!'))
                     console.log(error)
                 });
        }
    },
    data() {
        return {
            componentsEditable: []
        }
    },
    created() {
        this.componentsEditable = this.components;
    }
}
</script>
